import type { Pog } from "@CommonTypes/merchflow/pog/pog";
import { type PrimitiveAtom } from "jotai";
import { Flex } from "src/elements";
import styled from "styled-components";
import { FirstPdfPage } from "./FirstPdfPage";
import { PageHeader } from "./PageHeader";
import type { StoreDetail } from "./PageMerchflows_ExportPdf_StorePogId";
import { PageContainer, PdfFooter } from "./SingleBayPage";
import { sanitizeStoreTitle } from "./singleBayUtils";

const FileNameHeader = styled.div`
  height: 40px;
  border-bottom: 1px solid black;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
`;

interface FirstPageSectionProps {
  storeDetail: StoreDetail | null;
  pogAtom: PrimitiveAtom<Pog | null>;
  firstPageScale: number;
  totalPages: number;
  scaleX: number;
  scaleY: number;
}

export const FirstPageSection = ({
  storeDetail,
  pogAtom,
  firstPageScale,
  totalPages,
  scaleX,
  scaleY,
}: FirstPageSectionProps) => {
  const formattedTitle = sanitizeStoreTitle(
    storeDetail?.category_code,
    storeDetail?.store,
    storeDetail?.template_id,
  );

  return (
    <PageContainer>
      {storeDetail && <PageHeader storeDetail={storeDetail} />}
      {storeDetail && <FileNameHeader>{formattedTitle}</FileNameHeader>}
      {scaleX && scaleY && (
        <Flex
          flexGrow={1}
          minHeight="0"
          minWidth="0"
          overflow="hidden"
          justify="center"
          align="center"
        >
          <FirstPdfPage
            pogAtom={pogAtom}
            scale={firstPageScale}
            categoryName={storeDetail?.category_code}
          />
        </Flex>
      )}
      <PdfFooter storeDetail={storeDetail} segment="" pageNumber={1} totalPages={totalPages} />
    </PageContainer>
  );
};
